import styled from "styled-components";

export const ButtonCancel = styled.a`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.primary.purple};
  display: flex;
  align-items: center;
`;
export const ButtonCreate = styled.button`
  background: ${({ theme }) => theme.button.primary};
  color: ${({ theme }) => theme.primaryColorLight};
  font-size: 14px;
  font-weight: 500;
  border: none;
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 9em;
  height: 43.21px;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
export const ContentCreateSpeaker = styled.div`
  display: grid;
  grid-gap: 1em;
`;
export const ContentFields = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1em;
`;
export const ContentField = styled.div`
  display: grid;
  padding: 0.4rem;
  grid-template-columns: 1fr 1em;
  grid-auto-rows: 1em auto;
  align-items: center;

  label {
    grid-column: 1/3;
    color: ${({ theme }) => theme.primary.purple} !important;
    font-size: 15px;
    font-weight: bold;
  }
`;
export const ContentButtons = styled.div`
  display: flex;
  grid-gap: 1em;
  justify-content: flex-end;
`;
export const ContentFile = styled.div`
  label {
    font-weight: bold;
    color: ${({ theme }) => theme.primary.purple};
    font-size: 15px;
  }
  section {
    margin: 0 !important;
    height: 135px !important;
  }
`;
